








































import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  data() {
    return {
      generation: 0,
    };
  },

  computed: {
    data(): any[] {
      const that: any = this;
      const population = that.population;
      const generation = that.generation;

      return [
        ['A2A2', population.diploidData.length > 0 ? population.diploidData[generation].a2a2 : '-'],
        ['A1A2', population.diploidData.length > 0 ? population.diploidData[generation].both : '-'],
        ['A1A1', population.diploidData.length > 0 ? population.diploidData[generation].a1a1 : '-'],
      ];
    },
  },
})
export default class DiploidByGeneration extends Vue {
  @Prop() private population!: any;
}
